import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { EmployeeRoleModules, updateEmployeeRole } from '../../Data/EmployeeRoleData';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { IEmployeeRole } from '../../Interfaces/Admin/IEmployeeRole';
import produce from 'immer';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useDispatch } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { ApplicationDispatch, SET_LOADING, SET_SERVER_MESSAGE } from '../../store/application/types';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import {createStyles} from "@mui/material";
import { Theme } from '@mui/material/styles';
import { BusinessAction, BusinessActions } from '../../Data/BusinessRulesData';

// const useStyles: any = makeStyles((theme: Theme) =>
//   createStyles({
//     hover: {      
//       "&:hover": {
//         cursor: 'pointer'
//       }
//     },
//     container: {
//       maxHeight: "50vh",
//     },
//   })
// );

export interface EmployeeRoleEditProps {

}

export const EmployeeRoleEdit: React.FC<EmployeeRoleEditProps> = props => {  
  const dispatch = useDispatch<ApplicationDispatch>();
  const navigate = useNavigate();
  const params: Record<string, string | undefined> = useParams();
  const newEmployeeRole: IEmployeeRole = {
    id: '',
    name: '',
    description: '',
    deleted: false,
    createdDate: '',
    modifiedDate: '',
    modules: {},
    actions: {},
    configurationJson: '',
    allowReportsTo: false
  };
  const [employeeRoleEdit, setEmployeeRoleEdit] = useState<IEmployeeRole>(newEmployeeRole);
  // useEffect(() => {
  //   if (employeeRole) {
  //     setEmployeeRoleEdit(employeeRole);
  //   } else {      
  //     setEmployeeRoleEdit(newEmployeeRole);
  //   }
  // }, [employeeRole]);

  return (
    <Grid container spacing={3} style={{ padding: 24, width: '100%' }}>
      {/* <Grid item xs={12}>
        <Typography variant="h5">Edit Employee Role:</Typography>
      </Grid> */}

      <Grid item xs={6} md={3}>
        <TextField label="Name"
          required
          fullWidth
          value={employeeRoleEdit?.name}
          onChange={(e) => {
            setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
              employeeRoleEdit.name = e.target.value;
            }));
          }}
          error={!employeeRoleEdit.name?.trim()}
          helperText={!employeeRoleEdit.name && 'Required'}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <TextField label="Description"
          required
          fullWidth
          value={employeeRoleEdit?.description}
          onChange={(e) => {
            setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
              employeeRoleEdit.description = e.target.value;
            }));
          }}
          error={!employeeRoleEdit.description?.trim()}
          helperText={!employeeRoleEdit.description && 'Required'}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <FormControlLabel
          label="Active"
          control={
            <Switch
              checked={!employeeRoleEdit?.deleted}
              onChange={() => {
                setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                  employeeRoleEdit.deleted = !employeeRoleEdit.deleted;
                }))
              }}
              color="primary"
            />
          }
        />
      </Grid>

      
      <Grid item xs={12} md={6}>
        <Typography variant="h6">Data Access</Typography>
        <TableContainer component={Paper} style={{ maxHeight: "50vh" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>Module</TableCell>
                <TableCell>Field</TableCell>
                <TableCell>None</TableCell>
                <TableCell>View</TableCell>
                <TableCell>Edit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {EmployeeRoleModules?.map((m, i) => 
            <Fragment key={i}>
              <TableRow>
                <TableCell>{m.module}</TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <Radio
                    style={{
                      color: (typeof employeeRoleEdit?.modules?.[m.module]?.canView !== 'boolean'
                        && Object.keys(employeeRoleEdit?.modules?.[m.module]?.fields || {}).length)
                      ? "rgba(0, 0, 0, 0.2)"
                      : undefined
                    }}
                    checked={
                      !Object.keys(employeeRoleEdit?.modules?.[m.module]?.fields || {}).length
                      && !employeeRoleEdit?.modules?.[m.module]?.canView
                      && !employeeRoleEdit?.modules?.[m.module]?.canEdit
                    }
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        employeeRoleEdit.modules[m.module] = {
                          canView: false,
                          canEdit: false,
                          fields: {},
                        }
                      }));
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Radio
                    style={{
                      color: (typeof employeeRoleEdit?.modules?.[m.module]?.canView !== 'boolean'
                        && Object.keys(employeeRoleEdit?.modules?.[m.module]?.fields || {}).length)
                      ? "rgba(0, 0, 0, 0.2)"
                      : undefined
                    }}
                    checked={
                      employeeRoleEdit?.modules?.[m.module]?.canView === true
                      && employeeRoleEdit?.modules?.[m.module]?.canEdit === false
                    }
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        employeeRoleEdit.modules[m.module] = {
                          canView: true,
                          canEdit: false,
                          fields: {},
                        }
                      }));
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Radio
                    style={{
                      color: (typeof employeeRoleEdit?.modules?.[m.module]?.canView !== 'boolean'
                        && Object.keys(employeeRoleEdit?.modules?.[m.module]?.fields || {}).length)
                      ? "rgba(0, 0, 0, 0.2)"
                      : undefined
                    }}
                    checked={
                      employeeRoleEdit?.modules?.[m.module]?.canView === true
                      && employeeRoleEdit?.modules?.[m.module]?.canEdit === true
                    }
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        employeeRoleEdit.modules[m.module] = {
                          canView: true,
                          canEdit: true,
                          fields: {},
                        }
                      }));
                    }}
                  />
                </TableCell>
              </TableRow>
              {m.fields?.map((f, i) => 
              <TableRow key={i}>
                <TableCell></TableCell>
                <TableCell>{f}</TableCell>
                <TableCell>
                  <Radio
                    style={{
                      color: (typeof employeeRoleEdit?.modules?.[m.module]?.canView === 'boolean')
                      ? "rgba(0, 0, 0, 0.2)"
                      : undefined
                    }}
                    checked={
                      (employeeRoleEdit?.modules?.[m.module]?.canView === false
                        && employeeRoleEdit?.modules?.[m.module]?.canEdit === false)
                      || (typeof employeeRoleEdit?.modules?.[m.module]?.canView !== 'boolean'
                        && !employeeRoleEdit?.modules?.[m.module]?.fields[f]?.canView
                        && !employeeRoleEdit?.modules?.[m.module]?.fields[f]?.canEdit)
                    }
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        const module = employeeRoleEdit.modules[m.module];
                        if (!module.fields) {
                          module.fields = {};
                        }
                        if (module.canView !== undefined) {
                          for (const field of m.fields) {
                            module.fields[field] = {
                              canView: module.canView,
                              canEdit: module.canEdit,
                            };
                          }
                        }
                        module.canView = undefined;
                        module.canEdit = undefined;
                        module.fields[f] = {
                          canView: false,
                          canEdit: false,
                        };
                      }));
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Radio
                    style={{
                      color: (typeof employeeRoleEdit?.modules?.[m.module]?.canView === 'boolean')
                      ? "rgba(0, 0, 0, 0.2)"
                      : undefined
                    }}
                    checked={
                      (employeeRoleEdit?.modules?.[m.module]?.canView === true
                        && employeeRoleEdit?.modules?.[m.module]?.canEdit === false)
                      || (employeeRoleEdit?.modules?.[m.module]?.fields[f]?.canView === true
                        && employeeRoleEdit?.modules?.[m.module]?.fields[f]?.canEdit === false)
                    }
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        const module = employeeRoleEdit.modules[m.module];
                        if (!module.fields) {
                          module.fields = {};
                        }
                        if (module.canView !== undefined) {
                          for (const field of m.fields) {
                            module.fields[field] = {
                              canView: module.canView,
                              canEdit: module.canEdit,
                            };
                          }
                        }
                        module.canView = undefined;
                        module.canEdit = undefined;
                        module.fields[f] = {
                          canView: true,
                          canEdit: false,
                        };
                      }));
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Radio
                    style={{
                      color: (typeof employeeRoleEdit?.modules?.[m.module]?.canView === 'boolean')
                      ? "rgba(0, 0, 0, 0.2)"
                      : undefined
                    }}
                    checked={
                      (employeeRoleEdit?.modules?.[m.module]?.canView === true
                        && employeeRoleEdit?.modules?.[m.module]?.canEdit === true)
                      || (employeeRoleEdit?.modules?.[m.module]?.fields[f]?.canView === true
                        && employeeRoleEdit?.modules?.[m.module]?.fields[f]?.canEdit === true)
                    }
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        const module = employeeRoleEdit.modules[m.module];
                        if (!module.fields) {
                          module.fields = {};
                        }
                        if (module.canView !== undefined) {
                          for (const field of m.fields) {
                            module.fields[field] = {
                              canView: module.canView,
                              canEdit: module.canEdit,
                            };
                          }
                        }
                        module.canView = undefined;
                        module.canEdit = undefined;
                        module.fields[f] = {
                          canView: true,
                          canEdit: true,
                        };
                      }));
                    }}
                  />
                </TableCell>
              </TableRow>
              )}
            </Fragment>
            )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="h6">Actions</Typography>
        <TableContainer component={Paper} style={{ maxHeight: "50vh" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>No</TableCell>
                <TableCell>Yes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {Object.keys(BusinessActions)
            .map((x, i, a) => 
              <TableRow key={i}>
                <TableCell>{x}</TableCell>
                <TableCell>
                  {(BusinessActions[a[i-1] as BusinessAction]?.type 
                    !== BusinessActions[a[i] as BusinessAction]?.type) 
                  && BusinessActions[x as BusinessAction].type}
                </TableCell>
                <TableCell>
                  <Radio
                    checked={!employeeRoleEdit?.actions?.[x]}
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        employeeRoleEdit.actions[x] = false;
                      }));
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Radio
                    checked={!!employeeRoleEdit?.actions?.[x]}
                    onChange={() => {
                      setEmployeeRoleEdit(produce(employeeRoleEdit, employeeRoleEdit => {
                        employeeRoleEdit.actions[x] = true;
                      }));
                    }}
                  />
                </TableCell>
              </TableRow>
            )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={12}>
        <Button variant="contained"
          color="primary"
          onClick={async () => {
            try {
              dispatch({ type: SET_LOADING, payload: true });
              await updateEmployeeRole(employeeRoleEdit);
              navigate(-1);
            } catch (error) {
              dispatch({ 
                type: SET_SERVER_MESSAGE, 
                payload: {
                  message: error as string,
                  isError: true,
                },
              });
            } finally {
              dispatch({ type: SET_LOADING, payload: false });
            }
          }}
        >Save</Button>
        <Button variant="contained"
          style={{ marginLeft: 10 }}
          onClick={() => {
            navigate(-1);
          }}
        >Cancel</Button>
      </Grid>
    </Grid>
  );
}
